import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { AdServerFtCreativeFragmentDoc } from '../fragments/AdServerFTCreative.fragment';
import { AdServerSqtvCreativeFragmentDoc } from '../fragments/AdServerSQTVCreative.fragment';
import { AdServerQtvCreativeFragmentDoc } from '../fragments/AdServerQTVCreative.fragment';
export type GetPlacementMutationVariables = Types.Exact<{
	input: Types.GetAdInput;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform: Types.Platform;
	enableCreatives: Types.Scalars['Boolean']['input'];
}>;

export type GetPlacementMutation = {
	__typename?: 'Mutation';
	getPlacement: {
		__typename: 'GetAdPayload';
		bidID?: string | null;
		ads?: Array<
			| {
					__typename: 'CreativeFreeTrialContent';
					adContent: string;
					name: string;
					placementCandidateID: number;
					creativeID: number;
					offerSource?: Types.OfferSource | null;
					offer: {
						__typename: 'Offer';
						id: string;
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						standardWebURL?: string | null;
						mediaDealId?: number | null;
						streamUrl?: string | null;
						country: any;
						package: {
							__typename: 'Package';
							id: string;
							shortName: string;
							technicalName: string;
							packageId: number;
							clearName: string;
							icon: string;
							iconWide: string;
							maskReferrer?: boolean | null;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
					};
			  }
			| {
					__typename: 'CreativeGAMContent';
					adContent: string;
					name: string;
					placementCandidateID: number;
					creativeID: number;
			  }
			| {
					__typename: 'CreativeGenericContent';
					adContent: string;
					name: string;
					placementCandidateID: number;
					creativeID: number;
			  }
			| {
					__typename: 'CreativeQTVContent';
					adContent: string;
					name: string;
					placementCandidateID: number;
					creativeID: number;
					offer: {
						__typename: 'Offer';
						id: string;
						monetizationType: Types.MonetizationType;
						presentationType: Types.PresentationType;
						standardWebURL?: string | null;
						mediaDealId?: number | null;
						streamUrl?: string | null;
						country: any;
						package: {
							__typename: 'Package';
							id: string;
							shortName: string;
							packageId: number;
							clearName: string;
							icon: string;
							iconWide: string;
							maskReferrer?: boolean | null;
							technicalName: string;
							planOffers: Array<{ __typename: 'PackagePlanOffer'; retailPrice?: string | null }>;
						};
					};
					similarTitles: Array<{
						__typename: 'AdSimilarTitle';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						similarityScore: number;
						content: {
							__typename: 'AdSimilarTitleContent';
							title: string;
							posterUrl?: string | null;
							fullPath: string;
							scoring?: {
								__typename: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
								jwRating?: number | null;
								tomatoMeter?: number | null;
								certifiedFresh?: boolean | null;
								hideJWRating: boolean;
							} | null;
						};
						offers: Array<{
							__typename: 'Offer';
							id: string;
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							standardWebURL?: string | null;
							mediaDealId?: number | null;
							streamUrl?: string | null;
							country: any;
							package: {
								__typename: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								icon: string;
								iconWide: string;
								maskReferrer?: boolean | null;
								technicalName: string;
							};
						}>;
					}>;
			  }
			| {
					__typename: 'CreativeSQTVContent';
					adContent: string;
					name: string;
					placementCandidateID: number;
					creativeID: number;
					offerSource?: Types.OfferSource | null;
					similarityScore: number;
					offer: {
						__typename?: 'Offer';
						id: string;
						package: { __typename?: 'Package'; id: string; shortName: string };
					};
					similarTitle: {
						__typename: 'AdSimilarTitle';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename: 'AdSimilarTitleContent';
							title: string;
							posterUrl?: string | null;
							fullPath: string;
							backdrops: Array<{ __typename: 'Backdrop'; backdropUrl: string }>;
							scoring?: {
								__typename: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
								jwRating?: number | null;
								tomatoMeter?: number | null;
								certifiedFresh?: boolean | null;
								hideJWRating: boolean;
							} | null;
							interactions: { __typename: 'InteractionAttributes'; votesNumber: number };
							genres: Array<{ __typename: 'Genre'; translation: string }>;
							tags: Array<{ __typename: 'Tag'; technicalName: string; translatedName: string }>;
						};
						offers: Array<{
							__typename: 'Offer';
							id: string;
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							standardWebURL?: string | null;
							mediaDealId?: number | null;
							streamUrl?: string | null;
							country: any;
							package: {
								__typename: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								icon: string;
								iconWide: string;
								maskReferrer?: boolean | null;
								technicalName: string;
							};
						}>;
					};
			  }
			| {
					__typename: 'CreativeSRContent';
					adContent: string;
					name: string;
					placementCandidateID: number;
					creativeID: number;
			  }
			| {
					__typename: 'CreativeSwiperContent';
					adContent: string;
					name: string;
					placementCandidateID: number;
					creativeID: number;
			  }
		> | null;
	};
};

export const GetPlacementDocument = gql`
	mutation GetPlacement(
		$input: GetAdInput!
		$country: Country!
		$language: Language!
		$platform: Platform!
		$enableCreatives: Boolean!
	) {
		getPlacement(input: $input) {
			bidID
			ads {
				__typename
				adContent
				name
				placementCandidateID
				creativeID
				... on CreativeFreeTrialContent {
					offer {
						id
						package {
							id
							shortName
						}
					}
				}
				... on CreativeQTVContent {
					offer {
						id
						package {
							id
							shortName
						}
					}
				}
				... on CreativeSQTVContent {
					offer {
						id
						package {
							id
							shortName
						}
					}
				}
				... on CreativeFreeTrialContent @include(if: $enableCreatives) {
					...AdServerFTCreative
				}
				... on CreativeSQTVContent @include(if: $enableCreatives) {
					...AdServerSQTVCreative
				}
				... on CreativeQTVContent @include(if: $enableCreatives) {
					...AdServerQTVCreative
				}
			}
			__typename
		}
	}
	${AdServerFtCreativeFragmentDoc}
	${AdServerSqtvCreativeFragmentDoc}
	${AdServerQtvCreativeFragmentDoc}
`;
